import React from "react";
import BondDieFace from "./DieFace";
import { DICE_PICK_GROUPS, formatOddsMultiplier, oddsForPick, pickLabel } from "../../utils/bondDiceHelpers";

const BondDicePickSelector = ({ value, onChange, disabled = false, constants }) => {
  return (
    <div className="bdice-pick-groups">
      {DICE_PICK_GROUPS.map((group) => (
        <section key={group.id} className="bdice-pick-section" aria-label={group.label}>
          <header className="bdice-pick-section-head">
            <span className="bdice-pick-section-label">{group.label}</span>
            <span className="bdice-pick-section-odds">
              {formatOddsMultiplier(
                group.id === "exact" ? constants?.faceOdds || 6 : constants?.groupOdds || 2
              )}
            </span>
          </header>
          <div
            className="bdice-pick-grid"
            style={{ gridTemplateColumns: `repeat(${group.columns}, minmax(0, 1fr))` }}
            role="group"
          >
            {group.picks.map((pick) => {
              const active = value === pick;
              const odds = oddsForPick(pick, constants);
              const isFace = group.id === "exact";
              return (
                <button
                  key={pick}
                  type="button"
                  className={`bdice-pick-btn${active ? " active" : ""}${isFace ? " is-face" : ""}`}
                  disabled={disabled}
                  aria-pressed={active}
                  onClick={() => onChange(pick)}
                >
                  {isFace ? (
                    <span className="bdice-pick-die">
                      <BondDieFace value={pick} size="sm" />
                    </span>
                  ) : (
                    <span className="bdice-pick-label">{pickLabel(pick)}</span>
                  )}
                  <span className="bdice-pick-odds">{formatOddsMultiplier(odds)}</span>
                </button>
              );
            })}
          </div>
        </section>
      ))}
    </div>
  );
};

export default BondDicePickSelector;
